import { CharacterActionTypes } from '../actions/CharacterAction';
import WriteDataMode from '../actions/WriteDataMode';

const initStateForGetCharacters = {
    getCharactersCompleted: true,
    getCharactersCharacters: [],
    getCharactersError: null,
};

const initStateForGetCharacter = {
    getCharacterCompleted: true,
    getCharacterCharacters: new Map(),
    getCharacterError: null,
};

const initStateForWriteCharacter = {
    writeCharacterCompleted: true,
    writeCharacterMessage: '',
    writeCharacterDocId: '',
    writeCharacterError: null,
};

const initStateForVerifyCharacter = {
    verifyCharacterCompleted: true,
    verifyCharacterMessage: '',
    verifyCharacterError: null,
};

const initStateForRefreshCharacterGameData = {
    refreshCharacterGameDataCompleted: true,
    refreshCharacterGameDataMessage: '',
    refreshCharacterGameDataError: null,
};

const initStateForIdentifyCharacter = {
    identifyCharacterCompleted: true,
    identifyCharacterCharacters: [],
    identifyCharacterError: null,
};

const initState = {
    ...initStateForGetCharacters,
    ...initStateForGetCharacter,
    ...initStateForWriteCharacter,
    ...initStateForVerifyCharacter,
    ...initStateForRefreshCharacterGameData,
    ...initStateForIdentifyCharacter,
};

const CharacterReducer = (state = initState, action) => {
    switch (action.type) {
        case CharacterActionTypes.GetCharacters:
            return {
                ...state,
                getCharactersCompleted: false,
            };
        case CharacterActionTypes.GetCharactersDone:
            if (action.error) {
                return {
                    ...state,
                    getCharactersCompleted: true,
                    getCharactersError: action.error,
                };
            } else {
                return {
                    ...state,
                    getCharactersCompleted: true,
                    getCharactersCharacters: [...state.getCharactersCharacters, ...action.characters],
                    getCharactersError: null,
                };
            }
        case CharacterActionTypes.GetCharacter:
            return {
                ...state,
                getCharacterCompleted: false,
            };
        case CharacterActionTypes.GetCharacterDone:
            if (action.error) {
                return {
                    ...state,
                    getCharacterCompleted: true,
                    getCharacterError: action.error,
                }
            } else {
                const getCharacterCharacters = state.getCharacterCharacters;
                getCharacterCharacters.set(action.characterId, action.character);

                return {
                    ...state,
                    getCharacterCompleted: true,
                    getCharacterCharacters: getCharacterCharacters,
                    getCharacterError: null,
                }
            }
        case CharacterActionTypes.WriteCharacter:
            return {
                ...state,
                writeCharacterCompleted: false,
            };
        case CharacterActionTypes.WriteCharacterDone:
            if (action.error) {
                return {
                    ...state,
                    writeCharacterCompleted: true,
                    writeCharacterError: action.error,
                }
            } else {
                const getCharactersCharacters = state.getCharactersCharacters;
                const getCharacterCharacters = state.getCharacterCharacters;
                const character = action.character;

                if (action.mode === WriteDataMode.add) {
                    getCharactersCharacters.unshift(character);
                    getCharacterCharacters.set(character.id, character);
                } else if (action.mode === WriteDataMode.update) {
                    for (let i = 0; i < getCharactersCharacters.length; i++) {
                        if (getCharactersCharacters[i].id === character.id) {
                            getCharactersCharacters[i] = character;

                            break;
                        }
                    }

                    getCharacterCharacters.set(character.id, character);
                } else if (action.mode === WriteDataMode.delete) {
                    for (let i = 0; i < getCharactersCharacters.length; i++) {
                        if (getCharactersCharacters[i].id === character.id) {
                            getCharactersCharacters.splice(i, 1);

                            break;
                        }
                    }

                    getCharacterCharacters.delete(character.id);
                }

                return {
                    ...state,
                    getCharactersCharacters: getCharactersCharacters,
                    getCharacterCharacters: getCharacterCharacters,
                    writeCharacterCompleted: true,
                    writeCharacterMessage: action.message,
                    writeCharacterDocId: action.docId,
                    writeCharacterError: null,
                }
            }
        case CharacterActionTypes.VerifyCharacter:
            return {
                ...state,
                verifyCharacterCompleted: false,
            };
        case CharacterActionTypes.VerifyCharacterDone:
            if (action.error) {
                return {
                    ...state,
                    verifyCharacterCompleted: true,
                    verifyCharacterError: action.error,
                };
            } else {
                const getCharactersCharacters = state.getCharactersCharacters;
                const getCharacterCharacters = state.getCharacterCharacters;
                const character = action.character;

                for (let i = 0; i < getCharactersCharacters.length; i++) {
                    if (getCharactersCharacters[i].id === character.id) {
                        getCharactersCharacters[i] = character;

                        break;
                    }
                }

                getCharacterCharacters.set(character.id, character);

                return {
                    ...state,
                    getCharactersCharacters: getCharactersCharacters,
                    getCharacterCharacters: getCharacterCharacters,
                    verifyCharacterCompleted: true,
                    verifyCharacterMessage: action.message,
                    verifyCharacterError: null,
                };
            }
        case CharacterActionTypes.RefreshCharacterGameData:
            return {
                ...state,
                refreshCharacterGameDataCompleted: false,
            };
        case CharacterActionTypes.RefreshCharacterGameDataDone:
            if (action.error) {
                return {
                    ...state,
                    refreshCharacterGameDataCompleted: true,
                    refreshCharacterGameDataError: action.error,
                };
            } else {
                const getCharactersCharacters = state.getCharactersCharacters;
                const getCharacterCharacters = state.getCharacterCharacters;
                const character = action.character;

                for (let i = 0; i < getCharactersCharacters.length; i++) {
                    if (getCharactersCharacters[i].id === character.id) {
                        getCharactersCharacters[i] = character;

                        break;
                    }
                }

                getCharacterCharacters.set(character.id, character);

                return {
                    ...state,
                    getCharactersCharacters: getCharactersCharacters,
                    getCharacterCharacters: getCharacterCharacters,
                    refreshCharacterGameDataCompleted: true,
                    refreshCharacterGameDataMessage: action.message,
                    refreshCharacterGameDataError: null,
                };
            }
        case CharacterActionTypes.IdentifyCharacter:
            return {
                ...state,
                identifyCharacterCompleted: false,
            };
        case CharacterActionTypes.IdentifyCharacterDone:
            if (action.error) {
                return {
                    ...state,
                    identifyCharacterCompleted: true,
                    identifyCharacterError: action.error,
                };
            } else {
                return {
                    ...state,
                    identifyCharacterCompleted: true,
                    identifyCharacterCharacters: [...action.characters],
                    identifyCharacterError: null,
                };
            }
        default:
            return state;
    }
};

export default CharacterReducer;
